import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import TransitionsTooltips from './TransitionsTooltips';
import ClientProvider from './client';
export default createDemo(import.meta.url, TransitionsTooltips, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/tooltips/demos/transitions/TransitionsTooltips.tsx",
    "fileName": "TransitionsTooltips.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Button from '@mui/material/Button';\nimport Tooltip from '@mui/material/Tooltip';\nimport Fade from '@mui/material/Fade';\nimport Zoom from '@mui/material/Zoom';\n\nexport default function TransitionsTooltips() {\n  return (\n    <div>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 3,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Tooltip describeChild title=\"Add\">\n        <Button>Grow</Button>\n      </Tooltip>\n      <Tooltip\n        describeChild\n        title=\"Add\"\n        slots={{\n          transition: Fade,\n        }}\n        slotProps={{\n          transition: { timeout: 600 },\n        }}\n      >\n        <Button>Fade</Button>\n      </Tooltip>\n      <Tooltip\n        describeChild\n        title=\"Add\"\n        slots={{\n          transition: Zoom,\n        }}\n      >\n        <Button>Zoom</Button>\n      </Tooltip>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </div>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 35,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Button from '@mui/material/Button';\nimport Tooltip from '@mui/material/Tooltip';\nimport Fade from '@mui/material/Fade';\nimport Zoom from '@mui/material/Zoom';\n\nexport default function TransitionsTooltips() {\n  return (\n    <div>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 3
        },
        "      <Tooltip describeChild title=\"Add\">\n        <Button>Grow</Button>\n      </Tooltip>\n      <Tooltip\n        describeChild\n        title=\"Add\"\n        slots={{\n          transition: Fade,\n        }}\n        slotProps={{\n          transition: { timeout: 600 },\n        }}\n      >\n        <Button>Fade</Button>\n      </Tooltip>\n      <Tooltip\n        describeChild\n        title=\"Add\"\n        slots={{\n          transition: Zoom,\n        }}\n      >\n        <Button>Zoom</Button>\n      </Tooltip>\n"
      ],
      [
        "span",
        "frame",
        "    </div>\n  );\n}\n"
      ]
    ],
    "totalLines": 35,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Button",
      "@mui/material/Tooltip",
      "@mui/material/Fade",
      "@mui/material/Zoom"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
